/**
 * cachedTileInfo is a global variable for storing product tile data for a single pathname
 * At a time one pathName exists in cached badges. This is made sure deletePreviousMemoKeys function
 * Means At time one plp cache will be available in cachedBadges variable.
 * Used For: When user navigated from pdp to plp and come back to same plp with by pressing browser back
 * or using breadcrumb, we are reusing these values for each plp tile what was calculated last time
 * cacheKeys: { pathName, productId, key }
 * key: brand | badges | etc...
 */

export const cachedTileInfo = {};
export function removePreviousKeys(currentKey) {
  const keys = Object.keys(cachedTileInfo);
  if (keys.length === 1 && keys[0] === currentKey) return;
  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys) {
    if (key !== currentKey) {
      delete cachedTileInfo[key];
    }
  }
}

export function memoizeTileData(callback, cacheKeys, ...args) {
  const { pathName = '', productId, key } = cacheKeys;
  if (!cachedTileInfo[pathName]) {
    cachedTileInfo[pathName] = {};
  }
  if (!cachedTileInfo[pathName][productId]) {
    cachedTileInfo[pathName][productId] = {};
  }
  if (cachedTileInfo[pathName][productId][key]) return cachedTileInfo[pathName][productId][key];
  removePreviousKeys(pathName);
  const res = callback(...args);
  cachedTileInfo[pathName][productId][key] = res;
  return res;
}
